// filepath: c:\1\git\claim-169-card-generator\claim-169-webui-react\src\components\FaceCapture.tsx
import React, { useRef, useState } from 'react';

const settings = {
  cameraFacing: 'front', // or 'back'
};

interface FaceCaptureProps {
  onImageCapture: (src: string | null) => void;
  onCameraStateChange?: (isActive: boolean) => void; // Optional callback for camera state changes
}

const FaceCapture: React.FC<FaceCaptureProps> = ({ onImageCapture, onCameraStateChange }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [isCameraActive, setIsCameraActive] = useState(false);

  const startCamera = async () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      setIsCameraActive(true); // Show the video preview
      onCameraStateChange?.(true); // Notify parent component
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
    }
  };

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject as MediaStream;
      stream.getTracks().forEach((track) => track.stop()); // Stop all tracks
      videoRef.current.srcObject = null;
      setIsCameraActive(false); // Hide the video preview
      onCameraStateChange?.(false); // Notify parent component
    }
  };

  const captureImage = () => {
    if (canvasRef.current && videoRef.current) {
      const context = canvasRef.current.getContext('2d');
      if (context) {
        context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
        const imageSrc = canvasRef.current.toDataURL('image/png');
        onImageCapture(imageSrc);
      }
    }
  };
  
  return (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: isCameraActive && '50vh' || 'auto', // Adjust height based on camera stat
        backgroundColor: '#fff', // Black background for better contrast
        overflow: 'visible', // Prevent content from overflowing
      }}>
      {isCameraActive && (
        <video
          ref={videoRef}
          width="100%"
          height="80%"
          style={{ display: 'block', 
            margin: '0 auto',
            objectFit: 'contain', // Ensures the video fits within the container
            transform: settings.cameraFacing === 'front' ? 'scaleX(-1)' : 'none', // Mirror the video for the front camera
            }}
        />
      )}
      <div style={{ marginTop: '10px' }}>
        {!isCameraActive ? (
          <button onClick={startCamera} style={{ marginRight: '10px' }}>
            Start Camera
          </button>
        ) : (
          <>
            <button onClick={captureImage} style={{ marginRight: '10px' }}>
              Capture Image
            </button>
            <button onClick={stopCamera}>Stop Camera</button>
          </>
        )}
      </div>
      <canvas ref={canvasRef} width="300" height="200" style={{ display: 'none' }} />
    </div>
  );
};

export default FaceCapture;